import { Component, Input, OnDestroy, OnInit, OnChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from "@angular/platform-browser";
import { Subscription } from 'rxjs/Subscription';

import { InfoPage, InfoPageService, InfoPageCategory } from '../shared';
import {
  CanComponentDeactivate,
  EntityService,
  ModalService,
  ToastService,
  MessageService
} from '../../core';


@Component({
  moduleId: module.id,
  selector: 'bp-info-page',
  templateUrl: './info-page.component.html',
})

export class InfoPageComponent implements OnDestroy, OnInit {
  @Input() info: InfoPage;

  private dbResetSubscription: Subscription;
  id: any;
  fullMainHtml: any;
  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private infoPageService: InfoPageService,
    private toastService: ToastService,
    private sanitizer: DomSanitizer) { }

  ngOnInit() {

    this.route
      .params
      .map(params => params['id'])
      .do(id => this.id = +id)
      .subscribe(id => {
        if (this.id) {
          this.info = null;
           //console.log('ima id0a');
          this.getInfoPage();
          // this.getNewsCateogry();
        } else {
          //console.log('neam id', this.catId);
          //TODO: videti sta sa ovom dvojkom
          //this.router.navigateByUrl('/about-budget/31');
        }

      });

      document.addEventListener(`click`, e => {
        const origin = (e.target as Element).closest("a");

        if((<HTMLAnchorElement>origin).href.toString().includes('#_') )
        {
          e.preventDefault();
          this.scrollToElement((<HTMLAnchorElement>origin).hash.substring(1));
        }
      });

  }

  scrollToElement($element): void {

    var numberOfElements = ( document.getElementsByName($element));
    if(numberOfElements.length > 0)
    {
      document.getElementsByName($element)[numberOfElements.length-1].scrollIntoView();
    }
  }

  ngOnDestroy() {
    //this.dbResetSubscription.unsubscribe();
  }

  private getInfoPage() {
    if (this.id === 0) { return; }; //TODO: nece da radi zato sto ima id ===0

    this.infoPageService.getInfo(this.id)
      .subscribe(info => {

        this.fullMainHtml = this.sanitizer.bypassSecurityTrustHtml(info.mainText);
        this.info = info;
      });
  }


  private gotoInfoPages() {
    this.router.navigate(['/about-budget']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/about-budget/info-page/info-page.component.ts